export const CDN = 'CDN'